import { rebind, merge } from "../utils";
import { linearRegressionR2 as linearRegressionR2Calculator } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "linearRegressionR2";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.linearRegressionR2);

  const underlyingAlgorithm = linearRegressionR2Calculator();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.linearRegressionR2 = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor()) {
        throw new Error(`linearRegressionR2: Set accessor`);
      }
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
